module.exports = __webpack_public_path__ + "roboto-medium-webfont.848d2635199938129f4f.woff";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/roboto-medium-webfont.woff
// module id = ../../../../../src/assets/fonts/roboto-medium-webfont.woff
// module chunks = styles